// extracted by mini-css-extract-plugin
export default {"materials":"Material_materials__XHQ78"};